import { getItem } from "./localStorage";

export const FILE_UPLOAD_MODULES = {
  PRODUCTS: "product",
  GROUPS: "group",
  CAMPAIGNS: "campaign",
};

export const resolveProductFileUploadId = ({ productData, state } = {}) =>
  productData?.productId ||
  state?.productId ||
  state?.item?.productId ||
  state?.productData?.productId ||
  getItem("productId");

export const resolveGroupFileUploadId = ({ groupData, state } = {}) =>
  groupData?.groupId ||
  state?.getGroupProductFeatureSelector?.data?.data?.groupId ||
  state?.groupId ||
  state?.fromGroupData?.groupId ||
  getItem("groupId");

export const appendFileUploadModuleContext = (formData, { module, product, group } = {}) => {
  if (module) {
    formData.append("module", module);
  }

  if (product != null && product !== "") {
    formData.append("product", Number(product));
  }

  if (group != null && group !== "") {
    formData.append("group", Number(group));
  }
};
